import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { regex } from '@vfde-fe/ngx-lib/core';
import { CoreConfigurationsLoader } from '@vfde-fe/ngx-lib/services/core-configurations-loader';
import { of } from 'rxjs';
import { config } from '../../../config/pages-config';
import { environment } from '../../../environments/environment';
import { TOKEN_STORAGE } from '../constants/Defines';

/** ConfigLoaderService */
@Injectable()
export class ConfigLoaderService extends CoreConfigurationsLoader {
    /** httpClient */
    public httpClient: HttpClient;
    /** errors */
    public errors;
    /** features */
    public features;
    /** defaultGermanWordingfile */
    public defaultGermanWordingfile;
    /** deWordingfile */
    public deWordingfile;
    /** commonErrors */
    public commonErrors;
    /** commonWording */
    public commonWording;
    /** coreDefaultGermanWording */
    public coreDefaultGermanWording;
    /** context */
    public context: string;

    /**
     * constructor
     * @param injector
     */
     public constructor (private injector: Injector) {
        super();
        const currentUrl = window.location.href;
        const availableContext = currentUrl.match(regex.context);
        this.context = availableContext ? availableContext[1] : '';
    }

    /**
     * loads all configuration files at once by trying getting it from cms first then it gets the local one if it failed
     * the configutation files includes the following:
     * error-message - the error messages file
     * common.error - the common error messages for the general error
     * defaultWording - the local default wording file
     * deWording - the german wording file on CMS
     *             it first checks if context available and tries getting it,
     *             if it failed to load the context-dewording file for any reason it tries getting the general deWording
     */
    public load (): Promise<unknown> {

        const errorsConfig = new Promise((resolve) => {
            setTimeout(() => {
                const http = this.injector.get(HttpClient);
                http.get(environment.configPathErrorMessages + 'error-messages.json').subscribe(response => {
                    try {

                        this.errors = response;

                        resolve(this.errors);
                    } catch (error) {

                        console.warn('not valid json for error-messages.json file');

                        http.get(environment.configPathErrorMessages + 'error-messages.json').subscribe(response => {
                            this.errors = response;
                            resolve(this.errors);
                        });
                    }
                }, () => {
                    http.get(environment.configPathErrorMessages + 'error-messages.json').subscribe(response => {
                        this.errors = response;
                        resolve(this.errors);
                    });
                });
            });
        });

        const commonErrorsConfig = new Promise((resolve) => {
            setTimeout(() => {
                const http = this.injector.get(HttpClient);
                http.get(environment.cmsErrorMessagesPath + 'common.error.js').subscribe(response => {

                    try {

                        this.commonErrors = response;

                        resolve(this.commonErrors);
                    } catch (error) {

                        console.warn('not valid json for common.error.js file');

                        http.get(environment.configPath + 'common.error.json').subscribe(response => {
                            this.commonErrors = response;
                            resolve(this.commonErrors);
                        });
                    }
                }, () => {
                    http.get(environment.configPath + 'common.error.json').subscribe(response => {
                        this.commonErrors = response;
                        resolve(this.commonErrors);
                    });
                });
            });
        });

        const defaultGermanWording = new Promise((resolve) => {
            setTimeout(() => {
                const http = this.injector.get(HttpClient);
                http.get(environment.configPath + 'i18n/defaultWording.json').subscribe(response => {
                    this.defaultGermanWordingfile = response;
                    resolve(this.defaultGermanWordingfile);
                });
            });
        });

        const deWording = new Promise((resolve) => {
            setTimeout(() => {
                const http = this.injector.get(HttpClient);
                if (this.context) {
                    http.get(environment.cmsConfigPath + 'i18n/deWording-' + this.context + '.json').subscribe(response => {

                        try {

                            this.deWordingfile = response;
                            resolve(this.deWordingfile);
                        } catch (error) {
                            console.warn('not valid json for deWording' + this.context + '.json file');
                            this.deWordingfile = {};
                            resolve(this.deWordingfile);
                        }
                    }, () => {
                        http.get(environment.cmsConfigPath + 'i18n/deWording.json').subscribe(response => {

                            try {
                                this.deWordingfile = response;
                                resolve(this.deWordingfile);
                            } catch (error) {
                                console.warn('not valid json for deWording.json file');
                                this.deWordingfile = {};
                                resolve(this.deWordingfile);
                            }
                        }, () => {
                            resolve(null);
                        });
                    });
                } else {
                    http.get(environment.cmsConfigPath + 'i18n/deWording.json').subscribe(response => {

                        try {
                            this.deWordingfile = response;
                            resolve(this.deWordingfile);
                        } catch (error) {
                            console.warn('not valid json for deWording.json file');
                            this.deWordingfile = {};
                            resolve(this.deWordingfile);
                        }
                    }, () => {
                        resolve(null);
                    });
                }
            });
        });

        const coreWording = new Promise((resolve) => {

            setTimeout(() => {
                const http = this.injector.get(HttpClient);
                http.get(environment.cmsCommonWording).subscribe(response => {
                    try {

                        this.commonWording = response;

                        resolve(this.commonWording);
                    } catch (error) {

                        console.warn('not valid json for core-deWording.json file');
                    }
                }, () => {
                    resolve(null);
                });
            });
        });

        const coreDefaultGermanWording = new Promise((resolve) => {
            setTimeout(() => {
                const http = this.injector.get(HttpClient);
                http.get(environment.configPath + 'i18n/defaultWording-core.json').subscribe(response => {
                    this.coreDefaultGermanWording = response;
                    resolve(this.coreDefaultGermanWording);
                }, () => {
                    resolve(null);
                });
            });
        });

        return Promise.all([errorsConfig, commonErrorsConfig, defaultGermanWording, deWording, coreWording, coreDefaultGermanWording]);

    }

    /** loadPagesRoutes */
    public loadPagesRoutes (): object | object[] {
        return config;
    }

    /** getTokenConfig */
    public getTokenConfig () {
        return TOKEN_STORAGE.memory;
    }

    /** getcommonErrorsConfig */
    public getcommonErrorsConfig () {
        return this.commonErrors;
    }

    /** getErrorsConfig */
    public getErrorsConfig () {
        return this.errors;
    }
    /** getDefaultGermanWordingFile */
    public getDefaultGermanWordingFile () {
        return of(Object.assign(this.defaultGermanWordingfile, this.coreDefaultGermanWording));
    }
    /** getDeWordingFile */
    public getDeWordingFile () {

        return of(Object.assign(this.deWordingfile || {}, this.commonWording));
    }
    /** setCoreConfigRoute */
    public setCoreConfigRoute (): void {
        this.generalError = this.loadPagesRoutes()['generalError'].route;
        this.unauthorized = this.loadPagesRoutes()['unauthorized'].route;

    }
}
